<template>
  <v-card class="pa-6">
    <p class="font-bold font-size-20 mb-6">
      {{ $t('people.add_users_modal') }}
    </p>
    <v-card-text class="d-flex pa-0 justify-center">
      <div
        v-for="(type, index) in typeCards"
        :key="type.type"
        :class="index === typeCards.length - 1 ? 'ma-0' : 'mr-4'"
      >
        <OptionCard
          data-testid="add_user_option_card"
          data-tourid="add_user_option_card"
          :description="type.description"
          :icon="type.icon"
          :type="type.type"
          :title="type.title"
          @click="$emit('selected', type.type)"
        />
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'

import OptionCard from '@/components/OptionCardForModal.vue'

import { ADD_USER_TYPES } from './constants.js'

export default {
  name: 'TypeSelectionStep',

  components: {
    OptionCard,
  },

  props: {
    canInviteExternalUsers: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters(['organization']),

    typeCards() {
      const cards = [
        {
          type: ADD_USER_TYPES.MANUALLY,
          title: this.$t('common.users.create_manually'),
          icon: 'mdi-account-plus',
          description: this.$t('common.users.create_manually_description'),
        },
        {
          type: ADD_USER_TYPES.BULK,
          title: this.$t('common.users.create_through_template'),
          icon: 'mdi-file-excel',
          description: this.$t(
            'common.users.create_through_template_description'
          ),
        },
      ]

      if (this.canInviteExternalUsers) {
        cards.push({
          type: ADD_USER_TYPES.INVITE,
          title: this.$t('people.external_invitation.card_title'),
          icon: 'mdi-email-outline',
          description: this.$t('people.external_invitation.card_description'),
        })
      }

      return cards
    },
  },
}
</script>
